<script setup lang="ts">
import GraveyardWorkspace from "@/components/graveyard/GraveyardWorkspace.vue";

definePage({
  meta: {
    navActiveLink: "graveyard-graves",
    permissionKey: "page.graveyard.graves",
  },
});
</script>

<template>
  <GraveyardWorkspace />
</template>
